import { Axios, AxiosService } from '@/services/Axios';
import { CompanyVm } from '@/types';

class UserControllerClass {
  constructor(private APIService: AxiosService) {}

  acceptLeadsPassingProgram = (id: CompanyVm['id']) => {
    return this.APIService.patch(`/companies/${id}/programs`, { isLeadsPassingEligible: true });
  };
}

export const UserController = new UserControllerClass(Axios);
